export default {"src":"/_next/static/media/Coast_Logo.297b2e5c.svg","height":905,"width":905,"blurWidth":0,"blurHeight":0};